import axios from 'axios';
import AuthStore from 'stores/AuthStore';
import AppDispatcher from 'dispatcher/MgfDispatcher';
import languages from 'constants/languages.json';
import WebUtils from 'util/WebUtils';
import i18n from 'util/i18n';

class Utils {
  static urlBS() {
    return '';
  }

  static urlAPI() {
    return `${Utils.urlBS()}/rest`;
  }

  static urlWS() {
    const location = document.location;
    const protocol = (location.protocol === 'https:') ? 'wss' : 'ws';
    return `${protocol}://${location.host}/rest/filesocket`; // ?access_token=`;
  }

  static urlImg(path) {
    return `${Utils.urlBS()}/pub/${path}`;
  }

  static isMpg() {
    const byHost = document.location.host === 'admin.mypersonal.guide' || document.location.host === 'personal.myperfect.app';
    if (byHost) return true;
    try {
      if (AuthStore.isLogged() && AuthStore.isMypersonalguide()) return true;
    } catch (e) {}
    if (localStorage.getItem('mypersonalguide') && localStorage.getItem('mypersonalguide') !== 'undefined') return true;
    const byEnv = process.env.DOMAIN === 'MPG';
    return byEnv;
  }

  static isMpa() {
    if (Utils.isMpg()) return false;
    try {
      if (AuthStore.isLogged() && AuthStore.isMyperfectapp()) return true;
    } catch (e) {}
    if (localStorage.getItem('myperfectapp') && localStorage.getItem('myperfectapp') !== 'undefined') return true;
    const byHost = document.location.host === 'admin.myperfect.app';
    const byEnv = process.env.DOMAIN === 'MPA';
    return byHost || byEnv;
  }

  static isCorporateCtool() {
    if (localStorage.getItem('corporateCtool') === 'true') return true;
    return false;
  }

  static isCorporateCtoolApp() {
    if (localStorage.getItem('corporateCtoolApp') === 'true') return true;
    return false;
  }

  static getAgbsLink() {
    let link;
    if (Utils.isCorporateCtool()) {
      link = '/pub/contract/AGB_White_Label_V2_20260601.html';
    } else if (Utils.isMpa()) {
      if (Utils.isCorporateCtoolApp()) {
        link = '/pub/contract/AGB_Business_Partnerschaft_20260601.html';
      } else {
        link = '/pub/contract/AGB_myperfectapp_Business_20260601.html';
      }
    } else { // Mpg
      link = '/pub/contract/AGB_Privat_Basis_20260601.html';
    }
    return link;
  }

  static getMpgBgColor() {
    return '26a69a';
  }

  static getMpaBgColor() {
    return '1a7f84';
  }

  static fieldErrorStyle = {
    color: '#AA0000',
  }

  static setGoto(path) {
    window.gotonext = path;
  }

  static goGoto() {
    if (window.gotonext) {
      const g = window.gotonext;
      window.gotonext = null;
      window.location.hash = g;
    } else {
      window.history.back();
    }
  }

  static goHash(path) {
    window.location.hash = path;
  }

  static isSection(section, name) {
    if (!section || !section.list || section.list.length === 0) return false;
    for (let i = 0; i < section.list.length; i++) {
      const sect = section.list[i];
      if (sect.id === name) {
        return true;
      }
    }
    return false;
  }

  static getSection(section, name) {
    if (!section || !section.list || section.list.length === 0) return null;
    for (let i = 0; i < section.list.length; i++) {
      const sect = section.list[i];
      if (sect.id === name) {
        return sect;
      }
    }
    return null;
  }

  static showRespMsgs(resp, node, keepOld) {
    if (!keepOld) Utils.cleanMessages();
    if (!resp) return;
    if (resp.messages && resp.messages.length > 0) {
      for (let i = 0; i < resp.messages.length; i++) {
        const msg = resp.messages[i];
        const txt = i18n.t(msg.message, msg.params);
        Utils.showMessage(txt, msg.type);
      }
    }
    if (!node || !resp.ferr) return;
    if (node.setState) {
      const errors = {};
      for (const name in resp.ferr) {
        const msg = resp.ferr[name];
        errors[name] = i18n.t(msg.message, Utils.checkParam(msg.params));
      }
      node.setState({ errors });
    }
  }

  static showMessage(text, type) {
    if (!text || text.length === 0) return;
    const data = `<div class="mssg ${type || ''}">${text}</div>`;
    const container = document.getElementById('appMessage');
    const div = document.createElement('div');
    div.innerHTML = data;
    container.appendChild(div);
    div.timerId = setTimeout(
      () => {
        container.removeChild(div);
      },
      20000,
    );
  }

  static cleanMessages() {
    const container = document.getElementById('appMessage');
    if (container.children && container.children.length > 0) {
      for (let i = 0; i < container.children.length; i++) {
        const div = container.children[i];
        if (div.timerId) clearTimeout(div.timerId);
      }
    }
    container.innerHTML = '';
  }

  static checkParam(param) {
    let p = param;
    if (!p) p = param;
    if (!p.obj) p.obj = '';
    if (!p.val) p.val = '';
    return p;
  }

  static isNumeric(n) {
    return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
  }

  static doLater(v_this, v_func, v_args) {
    if (!v_this.dolater)v_this.dolater = {};
    const timer = v_this.dolater[v_func.name];
    if (timer) clearTimeout(timer);
    v_this.dolater[v_func.name] = setTimeout(() => {
      v_func.apply(v_this, v_args);
    }, 400);
  }

  static putWnCashe(key, obj) {
    if (!window.thcache)window.thcache = {};
    window.thcache[key] = obj;
  }

  static getWnCashe(key) {
    if (!window.thcache)window.thcache = {};
    return window.thcache[key];
  }

  static delWnCashe(key) {
    if (!window.thcache)window.thcache = {};
    delete window.thcache[key];
  }

  static makeMap(tnodes, mapPaths) {
    return Utils._makeMap(tnodes, false, null, null, mapPaths);
  }

  static makeOpenMap(tnodes, nodesOpen) {
    return Utils._makeMap(tnodes, true, nodesOpen, null, null);
  }

  static _makeMap(tnodes, useOpen, nodesOpen, _map, mapPaths) {
    let map = _map;
    if (!map) map = {};
    if (!tnodes || tnodes.length === 0) return map;
    let tnode;
    for (let i = 0; i < tnodes.length; i++) {
      tnode = tnodes[i];
      map[tnode.id] = tnode;
      if (mapPaths) mapPaths[tnode.data.path] = tnode;
      if (useOpen && (nodesOpen === null || !nodesOpen[tnode.id])) continue;
      Utils._makeMap(tnode.tnodes, useOpen, nodesOpen, map, mapPaths);
    }
    return map;
  }

  static getFilterVal(rlist, fname, isList) {
    if (!rlist || !rlist.filter || !rlist.filter.conds || rlist.filter.conds.length === 0) return '';
    for (let i = 0; i < rlist.filter.conds.length; i++) {
      const condition = rlist.filter.conds[i];
      if (condition.name === fname) {
        if (!condition.values || condition.values.length === 0) return '';
        if (isList) return condition.values;
        return condition.values[0];
      }
    }
    return '';
  }

  static setFilterVal(rlist, fname, val, isList) {
    Utils.initFilter(rlist);
    let condNum = -1;
    for (let i = 0; i < rlist.filter.conds.length; i++) {
      if (rlist.filter.conds[i].name === fname) {
        condNum = i;
        break;
      }
    }
    let condition = null;
    if (condNum < 0) {
      condition = {
        type: 'like',
        name: fname,
        values: [],
      };
    } else {
      condition = rlist.filter.conds[condNum];
    }
    if (isList) {
      condition.values = val;
    } else if (condition.values.length === 0) condition.values.push(val);
    else condition.values[0] = val;
    if (condNum < 0) rlist.filter.conds.push(condition);
    else rlist.filter.conds[condNum] = condition;
    if (!condition.values || condition.values.length === 0) {
      if (condNum < 0) condNum = 0;
      rlist.filter.conds.splice(condNum, 1);
    }
  }

  static initFilter(rlist) {
    if (!rlist.filter) {
      rlist.filter = {
        type: 'and',
        conds: [],
      };
    }
  }

  static getTableField(table, name) {
    if (!table || !name || !table.fields || table.fieldslength === 0) return null;
    for (let i = 0; i < table.fields.length; i++) {
      const field = table.fields[i];
      if (field.name === name) return field;
    }
    return null;
  }

  static lngTxt(lng) {
    for (let i = 0; i < languages.length; i++) {
      if (languages[i].name === lng) return languages[i].description;
    }
    return '';
  }

  static getDefaultLangItem(items, lang, isHtml) {
    if (!items) return '';
    if (items[lang] && items[lang].trim() !== '') return items[lang];
    for (const otherLang of languages.map((item) => item.name)) {
      if (otherLang === lang) continue;
      if (items[otherLang] && items[otherLang].trim() !== '') return (isHtml ? '--- <i>' : '') + otherLang.toUpperCase() + (isHtml ? '</i> ---<br />' : ': ') + items[otherLang];
    }
    return '';
  }

  static getCampaignIcon(type) {
    if (type === 'BNR') {
      return 'label';
    } if (type === 'MRK') {
      return 'pin_drop';
    } if (type === 'ADV') {
      return 'chat_bubble_outline';
    } if (type === 'SPE') {
      return 'update';
    } if (type === 'TFX') {
      return 'error_outline';
    }
    return null;
  }

  static add50PercentOpacityIfOpaque(color) {
    const tempElement = document.createElement('div');
    tempElement.style.color = color;
    document.body.appendChild(tempElement);
  
    // Computed style always returns "rgb(r, g, b)" or "rgba(r, g, b, a)"
    const computedColor = window.getComputedStyle(tempElement).color;
    document.body.removeChild(tempElement);
  
    // Extract all numbers (including decimals for alpha)
    const values = computedColor.match(/\d+(\.\d+)?/g);
    if (!values) return color;
  
    const [r, g, b, a] = values.map(Number);
  
    // If 'a' exists and is less than 1, the color already has transparency.
    // Note: values[3] is undefined for "rgb()" strings.
    if (a !== undefined && a < 1) {
      return computedColor; 
    }
  
    // Otherwise, return with 0.5 alpha
    return `rgba(${r}, ${g}, ${b}, 0.5)`;
  }

  static openLoadOverlay(msg) {
    document.getElementById('loadCoverMsg').innerHTML = (msg || (Utils.isMpa() || Utils.isMpg() ? 'myperfect.app' : 'myguide.city'));
    document.getElementById('loadCover').style.display = 'block';
  }

  static closeLoadOverlay() {
    document.getElementById('loadCover').style.display = 'none';
  }

  static switchHelp(path) {
    const box = document.getElementById('helpBox');
    const dat = document.getElementById('helpDat');
    const oldPath = box.getAttribute('data-path');
    dat.innerHTML = '<div><img style="width: 20px; height: 20px;" src="/images/tgload.gif"/></div>';
    if (!box.style.display || box.style.display === 'none') {
      box.setAttribute('data-path', path);
      box.style.display = 'block';
      return 'show';
    }
    if (oldPath === path) {
      box.setAttribute('data-path', '');
      box.style.display = 'none';
      return 'hide';
    }
    box.setAttribute('data-path', path);
    return 'show';
  }

  static randomStr(len) {
    let text = '';
    const possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < len; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  static randomInt(len) {
    return Number(Number(Math.random() * len).toFixed(0));
  }

  static clone(o) {
    if (!o) return null;
    return JSON.parse(JSON.stringify(o));
  }

  static getDestTitle(dest) {
    if (!dest || !dest.destinationInfo || !dest.destinationInfo.details) return null;
    for (const l in dest.destinationInfo.details) {
      return dest.destinationInfo.details[l].name;
    }
    return null;
  }

  static getViewportWidth() {
    let viewportWidth;
    // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
    if (typeof window.innerWidth !== 'undefined') {
      viewportWidth = window.innerWidth;
    } else if (typeof document.documentElement !== 'undefined' && typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) {
      // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
      viewportWidth = document.documentElement.clientWidth;
    } else {
      // older versions of IE
      viewportWidth = document.getElementsByTagName('body')[0].clientWidth;
    }
    return viewportWidth;
  }

  /* static setServerCookie(act, name, value, param, onload){
    var img = document.createElement('img');
    img.src = ServerConfig.BASE+ServerConfig.API+'/auth/stc/'+act+'/'+name+'/'+value;
    img.setAttribute("class","imgHide")
    img.setAttribute("data-name",name)
    if (param) {
      img.setAttribute("data-param",param)
    }
    if (onload) {
      img.onload = onload
    }
    document.appendChild(img);
  }

  static srvCSReq(type, msg) {
    var path = '/'
    if ( type === 'auth') path = '/auth/cs'
    var scr = document.createElement('script');
    scr.setAttribute('type', 'text/javascript');
    var query = ''
    for (var name in msg) {
      if (query !== '') query += '&'
      query += name+'='+msg[name]
    }
    //JSON.stringify(msg)

    if (!document.srvCSReq_auth) {
      document.srvCSReq_auth = function (t) {
        Utils.setCookie('token', t, 30)
      }
    }

    scr.setAttribute('src', ServerConfig.BASE+ServerConfig.API+path+'?'+query);
    document.getElementsByTagName('head')[0].appendChild(scr);
  } */

  /* static setServerToken(token, onload){
    var div_hide = document.getElementById('div_hide')
    if (!div_hide) {
      div_hide = document.createElement('div')
      div_hide.id = 'div_hide'
      div_hide.setAttribute("style","position: absolute; top: 20px; left: 20px; width: 300px; height: 200px; background-color: red; z-index: 100;")
      document.body.appendChild(div_hide)
    }
    var action = ServerConfig.BASE+ServerConfig.API+'/auth/token'
    var cont = '<iframe id="iframe_hide" name="iframe_hide"></iframe><form id="form_hide" name="form_hide" target="iframe_hide" action="'+action+'" method="post">'
    + '<input type="hidden" value="' + token + '" name="token"/><input value="Submit" type="submit"/></form>'

    cont += '<form action="'+action+'" method="post">'
    + '<input type="hidden" value="' + token + '" name="token"/><input value="Submit2" type="submit"/></form>'

    div_hide = document.getElementById('div_hide')
    console.log(div_hide)
    div_hide.innerHTML = cont
    var form_hide = document.getElementById('form_hide')
    console.log(form_hide)
    form_hide.submit()
  } */

  static async loadChatMessageAmounts(chatRoomIds) {

    const token = WebUtils.getCookie('token') || localStorage.getItem('token');
    const axConfig = {
      headers: {
        ...(token ? { 'Authorization': `Bearer ${token}`} : {}),
        'Content-Type': 'application/json'
      }
    };

    const url = `${Utils.urlAPI()}/chat/getMessages`;
    const response = await axios.post(url, { chatRoomId: (chatRoomIds || ['all']).join(','), fromBackoffice: true }, axConfig);

    const { data: { messages = [] } = {} } = response;
    const chatMessageAmounts = { all: 0 };

    (chatRoomIds || ['all']).forEach((chatRoomId) => chatMessageAmounts[chatRoomId] = 0);

    messages.forEach((message) => {
      if (message.templateChatRoomId) {
        if (chatMessageAmounts[message.templateChatRoomId] != undefined) {
          chatMessageAmounts[message.templateChatRoomId] += message.duration;
        } else {
          chatMessageAmounts[message.templateChatRoomId] = message.duration;
        }
      }
      if (chatMessageAmounts[message.roomId] != undefined) {
        chatMessageAmounts[message.roomId] += message.duration;
      } else {
        chatMessageAmounts[message.roomId] = message.duration;
      }
      chatMessageAmounts['all'] += message.duration;
    });

    Utils.refreshChatRoomAmountElems(chatRoomIds, chatMessageAmounts);

    AppDispatcher.dispatch({ actionType: 'UPD_LOADING_SUCCESS', chatMessageAmounts });

    return chatMessageAmounts;
  }

  static refreshChatRoomAmountElems(chatRoomIds, chatMessageAmounts) {

    if (chatMessageAmounts['all']) {
      localStorage.setItem('chatMessageAmounts', String(chatMessageAmounts['all']));
    } else {
      localStorage.removeItem('chatMessageAmounts');
    }

    const elements = document.querySelectorAll('.room_notify');
    if (!elements || !elements.length) return;

    elements.forEach((element) => {
      const roomNotifyDiv = element;
      let roomIds = roomNotifyDiv.getAttribute('data-room-ids');
      if (!roomIds) return;
      roomIds = roomIds.split(',');

      if (roomIds.indexOf('all') !== -1) {
        if (chatMessageAmounts['all'] != 0) {
          roomNotifyDiv.innerHTML = String(chatMessageAmounts['all']);
          roomNotifyDiv.classList.remove('hidden');
        } else {
          roomNotifyDiv.classList.add('hidden');
        }
        return;
      }

      if (chatRoomIds) {
        const updateRoom = roomIds.some((roomId) => chatRoomIds.has(roomId));
        if (!updateRoom) return;
      }

      let roomMessageAmount = 0;
      for (let roomId of roomIds) {
        roomMessageAmount += chatMessageAmounts[roomId] || 0;
      }

      if (roomMessageAmount != 0) {
        roomNotifyDiv.innerHTML = String(roomMessageAmount);
        roomNotifyDiv.classList.remove('hidden');
      } else {
        roomNotifyDiv.classList.add('hidden');
      }
    });
  }

  static useAbc = () => window.location.href.indexOf('abc.myperfect.app') !== -1 /* || window.location.href.indexOf('theguide.local.org') !== -1 */;

  static getAffLogo() {
    const logo = Utils.useAbc() ? { src: `https://abc.myperfect.app/pub/aff/logo_w400.jpg` } : {};
    return logo;
  }

  static getAffClassName() {
    const affClassName = Utils.useAbc() ? 'aff_abc' : '';
    return affClassName;
  }

  static getAffStyle() {
    const affStyle = Utils.useAbc() ? {
      '--bg_img': 'url(https://abc.myperfect.app/pub/aff/bg_2.jpg)',
      '--buttonColor': 'white',
      '--buttonTextColor': '#323232',
      '--panelColor': '#EF3D49a0',
      '--panelColor2': '#EF3D49c8',
      '--panelColor3': '#EF3D49',
    } : {};
    return affStyle;
  }
  
}

export default Utils;
